import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { CSSProperties, FC } from 'react';
import { usePropsValue } from '../hooks';
import './style.less';

export type StepItem = {
  title: string;
  desc?: string;
};

export type StepsProps = {
  stepList: StepItem[];
  activeIndex?: number;
  defaultActiveIndex?: number;
  onChange?: (currentIndex: number) => void;
  className?: string;
  style?: CSSProperties;
};

export const Steps: FC<StepsProps> = (props) => {
  const [activeIndex, setActiveIndex] = usePropsValue({
    value: props.activeIndex,
    defaultValue: props.defaultActiveIndex || 0,
    onChange: (currentIndex: number) => {
      props.onChange?.(currentIndex);
    },
  });

  const onChangeActive = hooks.useCallbackRef((index: number) => {
    setActiveIndex(index);
  });

  return (
    <div className={classNames('v-steps', props.className)} style={props.style}>
      {props.stepList.map((stepItem, index) => {
        return (
          <div
            className={classNames('v-step', {
              'v-step-active': activeIndex >= index,
              'v-step-current': activeIndex === index,
              'v-step-next-active': activeIndex + 1 == index,
            })}
            key={index}
          >
            <div className="v-step-indicator" onClick={onChangeActive.bind(null, index)}>
              <div className="v-step-dot-outer"></div>
              <div className="v-step-dot">{index + 1}</div>
            </div>
            <div className="v-step-content">
              <div className="v-step-title">{stepItem.title}</div>
              {stepItem.desc && <div className="v-step-desc">{stepItem.desc}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

Steps.defaultProps = {
  stepList: [],
  defaultActiveIndex: 0,
};
